<template>
  <span class="badge badge-team">Team mode</span>
</template>

<script>
export default {
  name: "TeamMode"
}
</script>

<style scoped>

</style>